export default __webpack_public_path__ + "static/17 - Elektromos autó töltő-435ba8b8805c70e866082c3517fa9400.jpg";